import '/app/brewery-packages/content/content-editor-plugin-quote/src/Quote.css-raw';
export default {
  "icon": "news-4a753f38-icon-D9SRnq",
  "quote": "news-4a753f38-quote-D9SRnq"
};